exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3e7zI ul{list-style-type:none;margin:0;padding:0}._3e7zI li{display:inline-block;position:relative}._3e7zI li:nth-child(n+2){margin-left:-30px}._3zgj7{margin-top:2%;margin-bottom:2%;border-right:2px solid hsla(0,0%,44%,.25)}._3j-RK{background-color:#fafafa}._2KSZW{width:82px;height:82px;border-radius:50%;border:3px solid #fff;display:inline-block;position:relative;-webkit-box-shadow:1px 1px 3px 1px rgba(0,0,0,.2);box-shadow:1px 1px 3px 1px rgba(0,0,0,.2)}.SdhHT{margin-top:5%}._2W98o{margin-bottom:2%}._3WIfO{background-color:#007a6e;color:#fff;width:193.86px}._1YIHs{color:#797979}._3gn99{font-size:15px}._3yQeW{margin-top:10px;margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"avataresUl": "_3e7zI",
	"divRow": "_3zgj7",
	"header": "_3j-RK",
	"imgAvatar": "_2KSZW",
	"buttonDiv": "SdhHT",
	"content": "_2W98o",
	"button": "_3WIfO",
	"wait": "_1YIHs",
	"turnwaitingTime": "_3gn99",
	"circularProgBar": "_3yQeW"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/TurnosEspontaneos/TurnosEspontaneos.css
// module id = 1310
// module chunks = 0 1